<template>
    <div id="nav-main">
      <router-link to="/"><img :src="require('@/assets/icon-home.png')" alt="Home Page"></router-link>
      <router-link to="/records"><img :src="require('@/assets/icon-records.png')" alt="Records Page">Records</router-link>
      <router-link to="/year"><img :src="require('@/assets/icon-years.png')" alt="Brees Over the Years">Over the Years</router-link>
      <router-link to="/charts"><img :src="require('@/assets/icon-charts.png')" alt="Stat Charts Page">Charts</router-link>
      <router-link to="/menu" aria-label="More Menu"><i class="fa fa-bars"></i></router-link>
    </div>
</template>

<script>

export default {
  name: 'MainNav',
  methods: { 
           scrollToTop() {
                window.scrollTo(0,0);
           }
   }
}

</script>

<style>

#nav-main {
    background: black;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    left: 0;
    z-index: 4;
    border-bottom: 2px solid #dace9a
}
div#nav-main > a {
    color: white;
    font-weight: 700;
    font-family: 'Teko', sans-serif;
    font-size: 24px;
    margin: 12px;
    text-decoration: none;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    transition-duration: 200ms;
}

div#nav-main > a:hover {
    color: #fff6d8;
}

div#nav-main > a > img {
    height: 37px;
    margin-right: 5px;
}

div#nav-main > a.router-link-active {
    text-decoration: none;
    color: #d3bc8d;
    transition-duration: 200ms;
}

div#nav-main > a.router-link-active:hover {
    color: #d3bc8d;
}

@media (max-width:600px) {
div#nav-main > a {
    font-size: 18px;
  }
  div#nav-main > a > img {
    height: 25px;
    margin-right: 5px;
}
}

@media (max-width:420px) {
div#nav-main > a {
    font-size: 14px;
  }
  div#nav-main > a > img {
    height: 25px;
    margin-right: 5px;
}
div#nav-main > a {
    margin: 7px;
}
}


@media (max-width:374px) {
  div#nav-main>a {
    font-size: 12px;
}
div#nav-main>a>img {
    height: 18px;
    margin-right: 3px;
}

}


</style>


// WEBPACK FOOTER //
// src/components/MainNav.vue